module.exports = __webpack_public_path__ + "img/1920x1080.dd6a1a63.jpg";